import React, {useEffect, useState} from 'react';

import {getYesNoData} from "./DropdownDataProviders";
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";
import {handleAjaxError} from "root/DataFunctions/BaseDataFns";

const DropdownYesNo = ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getYesNoData( props.dataType ).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        }).catch( error =>
        {
            handleAjaxError( error ) ;
        });
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownYesNo ;

DropdownYesNo.defaultProps =
{
    defaultClassName: 'form-group',
    renderErrorDiv: false,
    customer_id: 'user'
}

DropdownYesNo.propTypes = {
    onChange: PropTypes.func.isRequired,
    customer_id: PropTypes.string
};